import React from 'react';
import { MODALITY_OPTIONS, TASK_OPTIONS } from '../aiModelConstants';
import { chipClass } from '../aiModelUi';
import { AiModelModality, AiModelTask } from '../aiModelTypes';
import { StepProps } from './stepTypes';

const ModelTypeStep: React.FC<StepProps> = ({ form, isLight, patch }) => {
  return (
    <div className="space-y-4">
      <div>
        <p className={`text-[11px] font-medium mb-2 ${isLight ? 'text-neutral-600' : 'text-gray-400'}`}>Task</p>
        <div className="flex flex-wrap gap-1.5">
          {TASK_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => patch({ task: opt.value as AiModelTask })}
              className={`px-2.5 py-1 rounded-md text-[11px] font-medium border transition-colors ${chipClass(
                form.task === opt.value,
                isLight
              )}`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className={`text-[11px] font-medium mb-2 ${isLight ? 'text-neutral-600' : 'text-gray-400'}`}>Modality</p>
        <div className="flex flex-wrap gap-1.5">
          {MODALITY_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => patch({ modality: opt.value as AiModelModality })}
              className={`px-2.5 py-1 rounded-md text-[11px] font-medium border transition-colors ${chipClass(
                form.modality === opt.value,
                isLight
              )}`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModelTypeStep;
